import { render, staticRenderFns } from "./HeaderDecorate.vue?vue&type=template&id=9a59720c&scoped=true"
import script from "./HeaderDecorate.vue?vue&type=script&lang=js"
export * from "./HeaderDecorate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a59720c",
  null
  
)

export default component.exports